var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value,"label":"Search","maxlength":"30","clearable":""},on:{"input":_vm.filterChanged,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return $event.target.blur()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }